module.exports = __webpack_public_path__ + "img/instagram.d4810d45.png";